import IdentityManager from "@arcgis/core/identity/IdentityManager"
import { addInterceptor } from "@/v1-console/map/map.interceptor"
import type { MapAuthServiceTokenFragment }
  from "@/v1-console/map/auth/__types__/map.auth.fragment"

export function registerMapServerTokens(
  tokens: MapAuthServiceTokenFragment["Tokens"]
) {
  for(const t of tokens) {
    if(!t.Token) continue
    if(t.AuthType === "fixed-api-key") {
      addInterceptor({
        id: t.Code,
        urls: t.ServerUrl,
        before(params) {
          if (!params.requestOptions.query) params.requestOptions.query = {}
          params.requestOptions.query["api-key"] = t.Token
        }
      })
    }
    else if(t.AuthType.includes("arcgis")) {
      IdentityManager.registerToken({
        token: t.Token,
        expires: t.ExpiresAt,
        server: t.ServerUrl,
        ssl: t.IsSSL ?? true
      })
    }
  }
}
